import {
  CTA_UNLOCK_YOUR_OFFER,
  FAQ_HOW_DOES_MY_OFFER_WORK_ANSWER,
  CTA_GET_MY_FORMULA,
} from 'consts/copy';

import type { FaqProps } from '..';

export const FAQ_RETAIL_OFFER_CONTENT: FaqProps = {
  header: 'Still have questions? We’ve got answers.',
  faqs: [
    {
      question: 'What is Curology?',
      answer:
        'Curology is the first company to make personalized skincare formulas prescribed by real providers–all online. When you join Curology, you’re paired with a dermatology provider to help meet your skin goals and prescribe a custom prescription formula–delivered right to your door!',
    },
    {
      question: 'When will I see results?',
      answer:
        'With consistent use, many patients using these types of ingredients notice a difference within 6-12 weeks—but everyone’s skin is different, so this timeline might vary for you. It’s also important to remember that this is a long-term journey! We’re not just going for progress, but also prevention.',
    },
    {
      question: 'How does my offer work?',
      answer: FAQ_HOW_DOES_MY_OFFER_WORK_ANSWER,
    },
    {
      question: 'Can I adjust how often I get the products?',
      answer:
        'Yes! You can view and adjust the frequency of your shipments. If you run out sooner than expected, you can always request an earlier shipment.',
    },
  ],
  ctaButton: {
    buttonText: CTA_UNLOCK_YOUR_OFFER,
  },
};

export const FAQ_RETAIL_OFFER_RESKIN_CONTENT: FaqProps = {
  ...FAQ_RETAIL_OFFER_CONTENT,
  backgroundColor: '#F6F5EC',
  theme: 'secondary',

  ctaButton: {
    buttonText: CTA_GET_MY_FORMULA,
  },
};
